import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';

import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import RecordedContentContainer from "../RecordedContentContainer";
import ZoomService from "../../services/ZoomService";
import UserService from "../../services/UserService";
import TopBar from "../TopBar";
import LiveContentContainer from "../LiveContentContainer";
import JWTTokenContext from "../../JWTTokenContext";
import UpcomingContentContainer from "../UpcomingContentContainer";
import CropService from "../../services/CropService";
import firebase from "../../firebase";
import JoinUsContainer from "../JoinUsContainer";
import moment from "moment";
import StateService from "../../services/StateService";
import VideosService from "../../services/VideosService";

import AuthorService from "../../services/AuthorService";
import StageService from "../../services/StageService";
import CropsListHorizontalScroll from "../CropsListHorizontalScroll";
import BottomBar from "../BottomBar";
import ErrorBoundary from "../ErrorBoundry";
import UpcomingListContainer from "./UpcomingListContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F3F3F3",
    minHeight: window.innerHeight,
  },
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  cropsContainer: {
    display: "flex",
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
  },
  cropsCardWrapper: {
    flex: "0 0 auto",
  },
  cropThumbnail: {
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
  item: {
    textAlign: "center",
    padding: "4px",
    margin: "2px 0px",
  },
  greySection: {
    background: "#f1f1f1",
    padding: "4vh 0vh",
  },
  whiteSection: {
    background: "#fff",
    padding: "4vh 0vh 0vh 0vh",
  },
  whatYouGetTitleContainer: {
    marginBottom: theme.spacing(2),
  },
  whatYouGetText: {
    marginLeft: theme.spacing(4),
  },
  whatYouGetContainer: {
    marginTop: theme.spacing(4),
  },
  whatYouGetContent: {
    marginBottom: theme.spacing(3),
  },
  benefitContainer: {
    marginBottom: theme.spacing(3),
  },
}));

const meetingType = `meetings`;

function MeetingsList(props) {
  const classes = useStyles();
  // const language = useContext(LanguageContext);
  const cropNameObjFromRoute = useParams("crop");
  const cropNameFromRoute = cropNameObjFromRoute?.crop?.toLowerCase();
  let [userState, setUserState] = useState("");
  const [open, setOpen] = React.useState(true);
  let [jwtToken, setJwtToken] = useState("");
  let [userLanguageCode, setUserLanguageCode] = useState("");
  let [recordedMeetings, setRecordedMeetings] = useState({});
  let [loadingRecordedMeetings, setLoadingRecordedMeetings] = useState(false);
  let [upcomingMeetings, setUpcomingMeetings] = useState({});
  let [allUpcomingMeetings, setAllUpcomingMeetings] = useState([]);
  let [loadingUpcomingMeetings, setLoadingUpcomingMeetings] = useState(false);
  let [liveMeetings, setLiveMeetings] = useState([]);
  let [loadingLiveMeetings, setLoadingLiveMeetings] = useState(false);
  let [upcomingMeetingsCount, setUpcomingMeetingsCount] = useState(null);
  let [loading, setLoading] = useState(false);
  let [free, setFree] = useState(false);
  let [name, setName] = useState(null);
  let [mobile, setMobile] = useState(null);
  let [farmerCrops, setFarmerCrops] = useState([]);
  let userTypeVar = "premium";
  let [userType, setUserType] = useState(userTypeVar);
  let freeVar = false;

  let [userSource, setUserSource] = useState("");
  let cropFromRoute = {};
  if (props.referenceData && props.referenceData.crops && cropNameFromRoute) {
    cropFromRoute = CropService.getCropByName(
      props.referenceData.crops,
      cropNameFromRoute
    );
  }

  const handleClick = () => {
    setOpen(!open);
  };

  const fetchMeetings = async () => {
    setLoading(true);

    let { crops, authors, states, stages } = props.referenceData;

    let userStateFromLocal = localStorage.state;
    let userLangCodeFromLocal = localStorage.languageCode;

    let userSourceFromLocal = localStorage.userSource;
    let userSourceVar = "";
    if (!userSourceFromLocal || userSourceFromLocal === "") {
      userSourceVar = "WEB";
    } else {
      userSourceVar = userSourceFromLocal;
    }
    setUserSource(userSourceVar);

    let userStateName = userStateFromLocal;
    let userLanguageCodeVar = userLangCodeFromLocal;

    let userResponse = await UserService.getUser();
    let userFromResponse = userResponse.data;

    if (userFromResponse.name) {
      setName(userFromResponse.name);
    }

    if (userFromResponse.premium === false) {
      setFree(true);
      freeVar = true;
      userTypeVar = "free";
      setUserType(userTypeVar);
      localStorage.setItem("premium", userFromResponse.premium);
    } else {
      if (userFromResponse.migrated === true) {
        userTypeVar = "free_premium";
        setUserType(userTypeVar);
      } else if (userFromResponse.subscription_type === "free_premium") {
        userTypeVar = "free_premium";
        setUserType(userTypeVar);
      }
      if (
        userFromResponse.subscription_type &&
        userFromResponse.subscription_type === "freemium_1_month"
      ) {
        userTypeVar = "freemium_1_month";
        setUserType(userTypeVar);
      }
    }
    let mobileVar = "";
    if (userFromResponse.mobile) {
      setMobile(userFromResponse.mobile);
      mobileVar = userFromResponse.mobile;
      firebase.analytics().setUserId(userFromResponse.mobile);
      firebase.analytics().logEvent("meetings_list_page_viewed", {
        state_name: userStateName,
        mobile: userFromResponse.mobile,
        user_type: userTypeVar,
        user_source: userSourceVar,
      });
    }
    if (
      !userStateFromLocal ||
      userStateFromLocal === "" ||
      !userLangCodeFromLocal ||
      userLangCodeFromLocal === ""
    ) {
      if (userFromResponse.state) {
        let userStateFromResponse =
          userFromResponse.state.name_en.toLowerCase();
        let stateFromResponse = userFromResponse.state;
        localStorage.setItem("state", userStateFromResponse);
        setUserState(stateFromResponse);
        userStateName = userStateFromResponse;
        if (userFromResponse.state.language) {
          let userLangCodeFromResponse = userFromResponse.state.language.code;
          localStorage.setItem("languageCode", userLangCodeFromResponse);
          userLanguageCodeVar = userStateFromResponse;
          setUserLanguageCode(userLangCodeFromResponse);
        } else {
          userLanguageCodeVar = "mr";
          setUserLanguageCode("mr");
        }
      } else {
        setUserState(StateService.getStateByName(states, "maharashtra"));
        userStateName = "maharashtra";
        userLanguageCodeVar = "mr";
        setUserLanguageCode("mr");
      }
    } else {
      setUserState(StateService.getStateByName(states, userStateFromLocal));
      setUserLanguageCode(userLangCodeFromLocal);
    }

    ZoomService.getJWTToken().then((response) => {
      let token = response.data.token;
      setJwtToken(token);
    });

    setLoadingUpcomingMeetings(true);
    setLoadingLiveMeetings(true);

    ZoomService.getLiveMeetings(userStateName).then((response) => {
      let meetingsResponse = response.data;

      let meetings = meetingsResponse;

      let liveMeetingsFromService = ZoomService.parseMeetings(
        meetings,
        userLanguageCodeVar,
        userStateName,
        crops,
        states,
        authors
      );

      if (freeVar === true) {
        liveMeetingsFromService = _.filter(
          liveMeetingsFromService,
          (meeting) => {
            return meeting.free === true;
          }
        );
      }

      let liveMeetingsFiltered = [];

      if (cropNameFromRoute) {
        liveMeetingsFiltered = _.filter(liveMeetingsFromService, (meeting) => {
          return (
            meeting.crop.name_en.toLowerCase() ===
            cropNameFromRoute.toLowerCase()
          );
        });
      } else {
        liveMeetingsFiltered = liveMeetingsFromService;
      }

      setLiveMeetings(liveMeetingsFiltered);
      setLoadingLiveMeetings(false);
      ZoomService.getUpcomingMeetings(userStateName).then((response) => {
        let meetingsResponse = response.data;

        let meetings = meetingsResponse;

        let upcomingMeetingsFromService = ZoomService.parseMeetings(
          meetings,
          userLanguageCodeVar,
          userStateName,
          crops,
          states,
          authors
        );

        let upcomingMeetingsFiltered = [];

        if (cropNameFromRoute) {
          upcomingMeetingsFiltered = _.filter(
            upcomingMeetingsFromService,
            (meeting) => {
              return (
                meeting.crop.name_en.toLowerCase() ===
                cropNameFromRoute.toLowerCase()
              );
            }
          );
        } else {
          upcomingMeetingsFiltered = upcomingMeetingsFromService;
        }

        if (freeVar === true) {
          upcomingMeetingsFiltered = _.filter(
            upcomingMeetingsFiltered,
            (meeting) => {
              return meeting.free === true;
            }
          );
        }

        upcomingMeetingsFiltered = _.filter(
          upcomingMeetingsFiltered,
          (upcomingElement) => {
            return !_.some(liveMeetingsFiltered, (liveElement) => {
              return liveElement.id === upcomingElement.id;
            });
          }
        );

        if (upcomingMeetingsFiltered) {
          setUpcomingMeetingsCount(upcomingMeetingsFiltered.length);
        }
        setUpcomingMeetings(upcomingMeetingsFiltered);
        setAllUpcomingMeetings(upcomingMeetingsFiltered);
        setLoadingUpcomingMeetings(false);
      });
    });
  };

  useEffect(() => {
    if (
      props.referenceData &&
      !_.isEmpty(props.referenceData) &&
      props.loadingMasterData === "done"
    ) {
      fetchMeetings().then(() => {});
      UserService.logUser();
    }
  }, [props.referenceData, props.loadingMasterData]);

  return (
    <div className={classes.root}>
      <LanguageContext.Provider value={userLanguageCode}>
        <ErrorBoundary
          page={"crop-page"}
          section={"topbar"}
          userSource={userSource}
        >
          <TopBar userSource={userSource} location={`meetings-list-page`} />
        </ErrorBoundary>

        {liveMeetings && liveMeetings.length > 0 && (
          <ErrorBoundary
            page={"crop-page"}
            section={"live-meetings"}
            userSource={userSource}
          >
            <LiveContentContainer
              liveMeetings={liveMeetings}
              loading={loadingLiveMeetings}
              crops={props.referenceData.crops}
              userType={userType}
              farmerCrops={farmerCrops}
              userSource={userSource}
              location={`meetings-list-page`}
              hideTitle={true}
              noTopPadding={true}
              userState={userState}
            />
          </ErrorBoundary>
        )}

        <ErrorBoundary
          page={"crop-page"}
          section={"upcoming-meetings"}
          userSource={userSource}
        >
          <UpcomingListContainer
            allUpcomingMeetings={allUpcomingMeetings}
            upcomingMeetings={upcomingMeetings}
            loading={loadingUpcomingMeetings}
            recordedMeetings={recordedMeetings}
            liveMeetings={liveMeetings}
            loadingRecordedMeetings={loadingRecordedMeetings}
            crops={props.referenceData.crops}
            userType={userType}
            farmerCrops={farmerCrops}
            userSource={userSource}
            location={`meetings-list-page`}
            hideTitle={true}
            noTopPadding={liveMeetings && liveMeetings.length > 0}
            userState={userState}
          />
        </ErrorBoundary>

        {userSource === "WEB" && (
          <ErrorBoundary
            page={"crop-page"}
            section={"crops-list"}
            userSource={userSource}
          >
            <BottomBar
              languages={props.referenceData.languages}
              location={"croppage"}
              changeUserLanguage={props.changeUserLanguage}
              userSource={userSource}
            />
          </ErrorBoundary>
        )}
      </LanguageContext.Provider>
    </div>
  );
}

export default React.memo(MeetingsList);
